import { Component, Inject} from '@angular/core';
import { BrandingService } from '../../core/services/branding.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DisclosuresDialogData } from '../shared-components.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-disclosures-page',
    templateUrl: './disclosures-page.component.html',
    styleUrls: ['./disclosures-page.component.scss'],
    standalone: false
})
export class DisclosuresPageComponent {
  nameOfButton: string = 'total_premium.purchase';
  paymentMethod: string = 'form.credit_card';
  data: DisclosuresDialogData;
  brandingInfo$: Observable<any>;

  constructor(public dialogRef: MatDialogRef<DisclosuresPageComponent>,
              private brandingService: BrandingService,
              @Inject(MAT_DIALOG_DATA) public matData: DisclosuresDialogData) {
    this.data  = matData.pageData;
    this.brandingInfo$ = brandingService.brandingInfo$;
  }
}
